export default __webpack_public_path__ + "img/6cc69038c3994ef34722a01ecd29873a.svg";